
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateResultFormGroup() {
return new FormGroup({
})
;
}
      